(function() {
gridviewlist()
})();

function gridviewlist(){

  
  const viewToggleBtns = document.querySelectorAll('.view-toggle-btn');
  const productGrid = document.querySelector('.product-grid');
  
  if (!viewToggleBtns.length || !productGrid) return;
    console.log("run");
  // Load saved view preference
  const savedView = localStorage.getItem('collectionView') || 'grid';
  setView(savedView);
  
  viewToggleBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const view = this.getAttribute('data-view');
      setView(view);
      localStorage.setItem('collectionView', view);
    });
  });
  
  function setView(view) {
    viewToggleBtns.forEach(btn => {
      if (btn.getAttribute('data-view') === view) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
    
    if (view === 'list') {
      productGrid.classList.add('product-grid--list-view');
      productGrid.classList.remove('product-grid--small-view');
    } else {
      productGrid.classList.add('product-grid--small-view');
      productGrid.classList.remove('product-grid--list-view');
    }
  }
}